export const queryParams = [
  'columnOrder',
  'columnSizing',
  'date',
  'descriptionId',
  'groupId',
  'subject',
  'segment',
  'groupMemberId',
  'type',
  'errorSegment',
  'viewType',
  'entityType',
  'algorithmIds',
  'algorithmId',
  'algorithmCode',
  'targetId',
  'requiredKeyId',
  'requiredKeyIndex',
  'requiredKeyAlgorithmsId',
  'requiredKeyAlgorithmsIndex',
  'dataSourceId',
  'dataSourceIndex',
  'validationRuleId',
  'validationRuleIndex',
  'alternativeAlgorithmSetId',
  'alternativeAlgorithmSetIndex',
  'id',
  'dataObjectType',
  'processingDataObjectId',
  'sourceDataVersionId',
  'valueDate',
  'inputDataVersionId',
  'outputDataVersionId',
  'version',
  'valueDays',
  'groupDescriptionRef',
  'key',
  'dataObjectVersionId',
  'onlyLastValueDate',
  'periodSkipLastValueDate',
  'loadSavedState',
] as const;

export type QueryParamName = (typeof queryParams)[number];

export type QueryParams<Value extends string | number = string | number> =
  Record<QueryParamName, Value>;

export const getQueryParam = <Value extends string>(name: QueryParamName) =>
  (new URLSearchParams(window.location.search).get(name) || undefined) as
    | Value
    | undefined;

export const getQueryParams = () =>
  Object.fromEntries(
    new URLSearchParams(window.location.search).entries(),
  ) as Partial<QueryParams<string>>;
